import { Stone, Loc, FrontendGoban, FrontendToBackend } from "./backend-types";
import { useRef } from "react";
import { useState } from "react";

type Yx = {
  y: number;
  x: number;
};

type GobanProps = {
  pos: FrontendGoban | null;
  sendF2b: (f2b: FrontendToBackend) => void;
};

function oppColor(color: string): string {
  if (color === "Black") {
    return "White";
  }
  if (color === "White") {
    return "Black";
  }
  return "Black";
  // alert("internal error");
}

export function Goban({ sendF2b, pos }: GobanProps) {
  const [varHover, setVarHover] = useState<boolean>(false);

  async function boardClick(loc: Loc) {
    let f2b: FrontendToBackend = {
      enum_tag: "GobanClick",
      content: {
        loc,
      },
    };
    sendF2b(f2b);
  }

  const boardSize = 19;
  function line(from: Yx, to: Yx) {
    const loc = {
      y1: from.y,
      x1: from.x,
      y2: to.y,
      x2: to.x,
    };
    return (
      <line
        {...loc}
        key={JSON.stringify(loc)}
        stroke="black"
        strokeLinecap="round"
        strokeWidth={0.01}
      />
    );
  }

  const stoneRadius = 0.45;
  function svgCircle(loc: Loc, r: number, fill: string, stroke: string) {
    return (
      <circle
        cy={loc.row}
        cx={loc.col}
        r={r}
        fill={fill}
        stroke={stroke}
        strokeWidth="0.03"
        key={JSON.stringify(loc)}
      />
    );
  }
  function svgNumber(stone: Stone, n: number) {
    const drawStone = varHover;
    const maybeStone = drawStone ? svgStone(stone) : null;
    const textColor = drawStone ? oppColor(stone.player) : "black";
    return (
      <>
        {maybeStone}
        <text
          className="VariationNumber"
          y={stone.loc.row}
          x={stone.loc.col}
          key={String(stone)}
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
        >
          {n + 1}
        </text>
      </>
    );
  }
  function svgStone(stone: Stone) {
    return svgCircle(stone.loc, stoneRadius, stone.player, "black");
  }

  function svgLastMove(stone: Stone) {
    if (stone === null) return <></>;
    const p = (dr: number, dc: number) =>
      stone.loc.col + dc + "," + (stone.loc.row + dr) + " ";
    const triangleSize = stoneRadius * 0.75;
    const points = p(0, 0) + p(triangleSize, 0) + p(0, triangleSize);
    const fill = oppColor(stone.player);
    return <polygon points={points} fill={fill} />;
  }

  function svgCoord(label: number | string, x: number, y: number) {
    if (typeof label == "number") {
      label = String(
        ((boardSize + 1) / 2 - Math.abs((boardSize - 1) / 2 - label)) % 10
      );
    }
    return (
      <text
        className="GobanSvgCoord"
        x={x}
        y={y}
        key={label + String(x) + String(y)}
      >
        {label}
      </text>
    );
  }
  const svgRef = useRef<SVGSVGElement>(null);
  const clickOnBoard = async (e: any) => {
    const svgPoint = new DOMPointReadOnly(e.clientX, e.clientY).matrixTransform(
      svgRef.current!.getScreenCTM()!.inverse()
    );
    function onBoard(dim: number, size: number) {
      return 0 <= dim && dim < size;
    }
    const [y, x] = [svgPoint.y, svgPoint.x];
    const [ry, rx] = [Math.round(y), Math.round(x)];
    const [dy, dx] = [y - ry, x - rx];
    const dist = Math.sqrt(dy * dy + dx * dx);
    if (onBoard(ry, boardSize) && onBoard(rx, boardSize) && dist < 0.5) {
      boardClick({ row: ry, col: rx });
    }
    // console.log("dist:", ry, rx, dist);
  };

  let stones = pos !== null ? pos.goban_state.map(svgStone) : [];
  let var_numbers = pos !== null ? pos.variation.map(svgNumber) : [];
  const lastMove =
    pos !== null && pos.last_move !== undefined
      ? svgLastMove(pos.last_move)
      : [];

  const coordOffset = 0.7;
  const coordN = -coordOffset;
  const coordS = coordOffset + boardSize - 1;
  return (
    <div className="Goban">
      <svg
        onMouseEnter={() => setVarHover(true)}
        onMouseLeave={() => setVarHover(false)}
        className="GobanSvg"
        // coordinates 1 - 19 + margins
        viewBox={`-1 -1 ${boardSize + 1} ${boardSize + 1}`}
        onClick={clickOnBoard}
        ref={svgRef}
      >
        <g id="coords">
          {[...Array(boardSize).keys()].map((x) => svgCoord(x, coordN, x))}
          {[...Array(boardSize).keys()].map((x) => svgCoord(x, coordS, x))}
          {[...Array(boardSize).keys()].map((y) => svgCoord(y, y, coordN))}
          {[...Array(boardSize).keys()].map((y) => svgCoord(y, y, coordS))}
          {svgCoord("N", coordN, coordN)}
          {svgCoord("E", coordS, coordN)}
          {svgCoord("W", coordN, coordS)}
          {svgCoord("S", coordS, coordS)}
        </g>
        <g id="lines">
          {[...Array(boardSize).keys()].map((x) =>
            line({ y: 0, x }, { y: boardSize - 1, x })
          )}
          {[...Array(boardSize).keys()].map((y) =>
            line({ y, x: 0 }, { y, x: boardSize - 1 })
          )}
        </g>
        <g id="hoshi">
          {[3, 9, 15].map((row) =>
            [3, 9, 15].map((col) =>
              svgCircle({ row, col }, 0.04, "black", "black")
            )
          )}
        </g>
        <g id="stones">
          {stones}
          {lastMove}
        </g>
        <g id="var_numbers">{var_numbers}</g>
      </svg>
    </div>
  );
}
